// extracted by mini-css-extract-plugin
module.exports = {"breakBubble":"withLinking_breakBubble__2-HDE","breakBubbleHighlighted":"withLinking_breakBubbleHighlighted__3nLal"};